// extracted by mini-css-extract-plugin
export default {"color-grey-4":"#F5F4F2","colorGrey4":"#F5F4F2","color-black":"#000000","colorBlack":"#000000","title":"_3NjD0"};